<!--
 * @Author: Gaho
 * @Date: 2024-04-19 18:06:01
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-19 10:37:26
 * @Description: 
-->
<template>
    <div class="flex flex-1 relative flex-col-reverse">
        <div
            class="mb-[21px] w-full flex flex-1 items-center board-item"
            v-for="(row, rowIndex) in stairRows"
            :key="rowIndex"
        >
            <StairsTile
                :row="row"
                :row-index="rowIndex"
                :round="round"
                :itemClick="itemClick"
                :index="k"
                v-for="(v, k) in 10"
                :key="k"
                :bet-islocked="betIsLocked"
                :isGameContent="isGameContent"
                :stairRows="stairRows"
            />
            <Man :status="round.status || ''" :man="man" :round="round" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import StairsTile from './StairsTile.vue';
import Man from './Man.vue';
import { roundData } from '../data';

const props = defineProps({
    round: {
        type: Object as PropType<typeof roundData>,
        required: true,
    },
    man: {
        type: Object,
        required: true,
    },
    betIsLocked: {
        type: Boolean,
        required: true,
    },
    itemClick: {
        type: Function,
        required: false,
    },
    isGameContent:{
        type: Boolean,
        default: false
    },
    stairRows: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:round']);
</script>

<style lang="scss" scoped>
.board-item {
    @media (max-width: 500px) {
        margin-bottom: 10px;
    }
}
</style>
